export default {
  data() {
    return {
      previousQuestionId: null,
      previousQuestionTitle: '',
      triageAnsweractionItems: [
        {
          title: 'افزودن سوال',
          id: '1',
          type: 'question',
          icon: 'mdi-message-question mdi-18px',
        },
        { title: 'ویرایش', id: '2', type: 'edit', icon: 'mdi-pencil mdi-18px' },
        { title: 'حذف', id: '3', type: 'delete', icon: 'mdi-delete mdi-18px' },
      ],
      triageAnswerId: null,
      confirmType: '',
      disabelConfirm: false,
      siteMap: false,
      siteMapItems: [],
    };
  },
  methods: {
    showConfirmDialogFunction: function () {
      if (this.confirmType == 'delete') {
        this.$refs.confirm.title = 'حذف پاسخ';
        this.$refs.confirm.text = 'از حذف پاسخ اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confirmType == 'delete') {
        this.disabelConfirm = true;
        this.deleteTriageAnswerFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confirmType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    setActionType: function (type, data) {
      if (type == 'question') {
        if (data.nextTriageQuestion) {
          if (data.nextTriageQuestion.chiefComplaint) {
            let pageType = localStorage.getItem('qType');
            if (pageType == 'general') {
              this.showGoToError(data);
              return;
            }
            let chiefId = localStorage.getItem('adminCheifComplaint');
            if (data.nextTriageQuestion.chiefComplaint.id != chiefId) {
              this.showGoToError(data);
              return;
            }
          }
        }
        this.goToAddQuestionPage(data);
      } else if (type == 'edit') {
        this.goToAddAnswerPage(2, data.id);
      } else if (type == 'delete') {
        this.triageAnswerId = data.id;
        this.confirmType = 'delete';
        this.showConfirmDialogFunction();
      }
    },
    showGoToError: function (data) {
      let qTitle = data.nextTriageQuestion.title;
      let chiefComplantTitle = data.nextTriageQuestion.chiefComplaint.title;
      let text =
        'جواب انتخابی به شکایت' +
        ' ' +
        '`' +
        chiefComplantTitle +
        '`' +
        ' ' +
        'سوال' +
        ' ' +
        '`' +
        qTitle +
        ' ' +
        '`' +
        'ارجاع داده شده است.';
      this.snackText = text;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#0A6ADA';
      this.snakIcon = 'mdi-information';
      this.disabelConfirm = false;
      return;
    },
    goToAddAnswerPage: function (type, id) {
      let info = this.previousQuestionId + '-' + type + '-' + id;
      this.$router.push({ name: 'addTriageAnswer', params: { id: info } });
    },
    goToAddQuestionPage: function (data) {
      let pageType = localStorage.getItem('qType');
      if (pageType == 'general') {
        this.generateSiteMap(1, data, 'sss');
        let tempPath = localStorage.getItem('path');
        tempPath = tempPath + '-' + this.$route.params.id;
        localStorage.setItem('path', tempPath);
        let id = data.id;
        this.$router.push({
          name: 'generalTriageQuestion',
          params: { id: id },
        });
      } else if (pageType == 'triage') {
        this.generateSiteMap(2, data, 'sss');
        let tempPath = localStorage.getItem('path');
        tempPath = tempPath + '-' + this.$route.params.id;
        localStorage.setItem('path', tempPath);
        let id = data.id;
        this.$router.push({ name: 'triageQuestion', params: { id: id } });
      }
    },
    backToQuestionPage: function () {
      this.removeLastPath();
      let pageType = localStorage.getItem('qType');
      if (pageType == 'general') {
        let tempPath = localStorage.getItem('path');
        let info = '';
        if (tempPath.length > 4) {
          let path = tempPath.split('-');
          info = path[path.length - 1];
          let mypath = '';
          for (let i = 0; i < path.length - 1; i++) {
            mypath += path[i] + '-';
          }
          mypath = this.removeLastCharechter(mypath);
          localStorage.setItem('path', mypath);
          this.$router.push({
            name: 'generalTriageQuestion',
            params: { id: info },
          });
        } else {
          localStorage.setItem('path', '');
          this.$router.push({ name: 'generalTriageQuestion' });
        }
      } else if (pageType == 'triage') {
        let tempPath = localStorage.getItem('path');
        let info = '';
        if (tempPath.length > 4) {
          let path = tempPath.split('-');
          info = path[path.length - 1];
          let mypath = '';
          for (let i = 0; i < path.length - 1; i++) {
            mypath += path[i] + '-';
          }
          mypath = this.removeLastCharechter(mypath);
          localStorage.setItem('path', mypath);
          this.$router.push({ name: 'triageQuestion', params: { id: info } });
        } else {
          localStorage.setItem('path', '');
          this.$router.push({ name: 'triageQuestion' });
        }
      }
    },
    removeLastPath: function () {
      let map = localStorage.getItem('qSiteMap');
      if (map) {
        if (map.includes('_')) {
          let path = map.split('_');
          for (let i = 0; i < path.length; i++) {
            if (path[i] == '') {
              path.splice(i, 1);
            }
          }
          if (path.length > 1) {
            let allPath = '';
            for (let i = 0; i < path.length - 1; i++) {
              let info = path[i] + '_';
              allPath += info;
            }
            localStorage.setItem('qSiteMap', allPath);
          } else {
            localStorage.removeItem('qSiteMap');
          }
        }
      }
    },
    generateSiteMap: function (type, data, selectedItem) {
      if (type == 1) {
        //general
        let map = localStorage.getItem('qSiteMap');
        let path = map.split('_');
        if (map.includes(selectedItem)) {
          console.log(selectedItem);
        } else {
          let info = 'a-' + this.$route.params.id + '-' + data.title + '-' + path.length + 1 + '_';
          let pathInfo = map + info;
          localStorage.setItem('qSiteMap', pathInfo);
        }
      } else if (type == 2) {
        //triage
        let map = localStorage.getItem('qSiteMap');
        let path = map.split('_');
        if (map.includes(selectedItem)) {
          console.log(selectedItem);
        } else {
          let info = 'a-' + this.$route.params.id + '-' + data.title + '-' + path.length + 1 + '_';
          let pathInfo = map + info;
          localStorage.setItem('qSiteMap', pathInfo);
        }
      }
    },
    showSiteMap: function () {
      this.siteMap = true;
      this.siteMapItems = [];
      let map = localStorage.getItem('qSiteMap');
      let path = map.split('_');
      for (let i = 0; i < path.length; i++) {
        if (path[i] == '') {
          path.splice(i, 1);
        }
      }
      for (let i = 0; i < path.length; i++) {
        let pathInfo = path[i].split('-');
        this.siteMapItems.push({
          title: pathInfo[2],
          type: pathInfo[0],
          urlId: pathInfo[1],
          id: pathInfo[3],
        });
      }
    },
    closeSiteMap: function () {
      this.siteMapItems = [];
      this.siteMap = false;
    },
    goToSiteMapItem: function (data) {
      let map = localStorage.getItem('qSiteMap');
      let path = map.split('_');
      for (let i = 0; i < path.length; i++) {
        if (path[i] == '') {
          path.splice(i, 1);
        }
      }
      let allInfo = '';
      let counter = 0;
      for (let i = 0; i < path.length; i++) {
        let pathInfo = path[i].split('-');
        let temp = {
          title: pathInfo[2],
          type: pathInfo[0],
          urlId: pathInfo[1],
          id: pathInfo[3],
        };
        if (temp.id != data.id) {
          let rouet = temp.type + '-' + temp.urlId + '-' + temp.title + '-' + i + 1 + '_';
          allInfo += rouet;
          counter++;
        } else {
          if (data.type == 'a') {
            localStorage.setItem('qSiteMap', allInfo);
            let tempPath = localStorage.getItem('path');
            let tempPathSplited = tempPath.split('-');
            counter++;
            let backRouteIds = '';
            for (let j = 0; j < tempPathSplited.length - counter; j++) {
              backRouteIds += tempPathSplited[j] + '-';
            }
            backRouteIds = this.removeLastCharechter(backRouteIds);
            localStorage.setItem('path', backRouteIds);
            let flag = false;
            if (this.$route.name == 'triageAnswer') {
              flag = true;
            }
            this.$router.push({
              name: 'triageAnswer',
              params: { id: data.urlId },
            });
            if (flag) {
              window.location.reload();
            }
          } else if (data.type == 'q') {
            if (data.urlId == 'noId') {
              localStorage.setItem('qSiteMap', '');
              localStorage.setItem('path', '');
              let flag = false;
              if (this.$route.name == 'generalTriageQuestion') {
                flag = true;
              }
              this.$router.push({ name: 'generalTriageQuestion' });
              if (flag) {
                window.location.reload();
              }
            } else {
              localStorage.setItem('qSiteMap', allInfo);
              let tempPath = localStorage.getItem('path');
              let tempPathSplited = tempPath.split('-');
              ///counter++;
              let backRouteIds = '';
              for (let j = 0; j < tempPathSplited.length - counter; j++) {
                backRouteIds += tempPathSplited[j] + '-';
              }
              backRouteIds = this.removeLastCharechter(backRouteIds);
              localStorage.setItem('path', backRouteIds);
              let flag = false;
              if (this.$route.name == 'generalTriageQuestion') {
                flag = true;
              }
              this.$router.push({
                name: 'generalTriageQuestion',
                params: { id: data.urlId },
              });
              if (flag) {
                window.location.reload();
              }
            }
          } else if (data.type == 'qt') {
            if (data.urlId == 'noId') {
              localStorage.setItem('qSiteMap', '');
              localStorage.setItem('path', '');
              let flag = false;
              if (this.$route.name == 'triageQuestion') {
                flag = true;
              }
              this.$router.push({ name: 'triageQuestion' });
              if (flag) {
                window.location.reload();
              }
            } else {
              localStorage.setItem('qSiteMap', allInfo);
              let tempPath = localStorage.getItem('path');
              let tempPathSplited = tempPath.split('-');
              //counter++;
              let backRouteIds = '';
              /*for (let j = 0; j < tempPathSplited.length - counter; j++) {
                                backRouteIds += tempPathSplited[j] + "-";
                            }*/
              for (let j = 0; j < counter; j++) {
                backRouteIds += tempPathSplited[j] + '-';
              }
              backRouteIds = this.removeLastCharechter(backRouteIds);
              localStorage.setItem('path', backRouteIds);
              let flag = false;
              if (this.$route.name == 'triageQuestion') {
                flag = true;
              }
              this.$router.push({
                name: 'triageQuestion',
                params: { id: data.urlId },
              });
              if (flag) {
                window.location.reload();
              }
            }
          }
        }
      }
    },
  },
};
